module.exports = __webpack_public_path__ + "img/title2.0463da81.png";